import type { PropsWithChildren } from "react";
import { createContext } from "react";
import type { AgentInfo, Inbox } from "../../../../api/types/inboxesTypes";
import type { EditInboxChannelState, InboxChannelValidationResult } from "./editInboxChannelState";

export interface Props {
  hasEditPermissions: boolean;
  inbox: Inbox;
  onInboxUpdated: (inbox: Inbox) => void;
  editedChannelState: EditInboxChannelState | undefined;
  setEditedChannelState: React.Dispatch<React.SetStateAction<EditInboxChannelState | undefined>>;
  editedChannelValidationResults: InboxChannelValidationResult | undefined;
  agents: AgentInfo[];
}

const AgentInboxSettingsContext = createContext<Props | undefined>(undefined);

export const AgentInboxSettingsContextProvider = ({ children, ...props }: PropsWithChildren<Props>) => (
  <AgentInboxSettingsContext value={props}>{children}</AgentInboxSettingsContext>
);

export default AgentInboxSettingsContext;
